import React from 'react';
import { Dialog, Paper } from "@mui/material";
import Draggable from "react-draggable";
import { CloseOutlined, DragIndicatorOutlined } from "@mui/icons-material";
import { PDFViewer } from "~/components/PDFViewer";
// Draggable modal for past notes
function PaperComponent(props) {
    return (React.createElement(Draggable, { handle: "#draggable-icon", cancel: '[class*="MuiDialogContent-root"]', bounds: 'parent' },
        React.createElement(Paper, { style: { maxWidth: '700px' }, ...props })));
}
export const PastReportView = (props) => {
    const { reportId, onClose } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { hideBackdrop: true, open: true, onClose: onClose, PaperComponent: PaperComponent, disableEnforceFocus: true, style: { pointerEvents: 'none', marginLeft: 'auto' }, PaperProps: { style: { pointerEvents: 'auto', maxWidth: '700px', marginLeft: 'auto' } } },
            React.createElement("div", { style: { height: '100%', width: '675px' } },
                React.createElement("div", { className: 'flex p-2' },
                    React.createElement(DragIndicatorOutlined, { style: { cursor: 'move' }, id: 'draggable-icon' }),
                    React.createElement("div", null, "Report View"),
                    React.createElement(CloseOutlined, { style: { marginLeft: 'auto', float: 'right', cursor: 'pointer' }, onClick: onClose })),
                React.createElement("div", { className: "bg-app-slate-charcoal flex-grow grid place-items-center overflow-auto" },
                    React.createElement(PDFViewer, { file: reportId }))))));
};
